import React from 'react';
import PropTypes from 'prop-types';
import { createModal } from 'react-modal-promise';
import { COUNTRIES } from '@upstart/harmony/lib/constants';
import '../ReactModal/reactModal.scss';

const prodigyModal = ({ close, value }) => (
  <div className="p-modal-container">
    <div className="p-modal">
      <div className="p-modal-text">
        <h2>
          Are You Sure You Want to Change Your Country to{' '}
          <span className="highlight-value">{COUNTRIES[value]}</span>?
        </h2>
      </div>
      <i
        onClick={() => close(false)}
        className="modal-close close icon"
        alt="close"
      />
      <div className="p-modal-body">
        <p>
          Changing your dealership country will reset default localisation
          configurations. Your existing address information will be lost.
        </p>
      </div>
      <div className="p-modal-actions">
        <button
          className="btn btn-primary btn-large btn-large-default"
          onClick={() => close(true)}
        >
          Yes Change to{' '}
          <span className="highlight-value">{COUNTRIES[value]}</span>
        </button>
        <button
          className="btn btn-default btn-large"
          onClick={() => close(false)}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);

prodigyModal.propTypes = {
  close: PropTypes.func,
  value: PropTypes.string,
};

const ChangeCountryChallengeModal = createModal(prodigyModal);

export default ChangeCountryChallengeModal;
